import { render, staticRenderFns } from "./handleModal.vue?vue&type=template&id=13c63387&scoped=true"
import script from "./handleModal.vue?vue&type=script&lang=js"
export * from "./handleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c63387",
  null
  
)

export default component.exports